import { observer } from 'mobx-react-lite';
import { Grid } from 'semantic-ui-react';
import { useStore } from '../../../app/stores/store';

import DashboardBillingForm from '../Orders/Outwards/DashboardBillingForm';
import ChartData from '../Charts/ChartData';
import Outwardstable from '../Orders/Outwards/Outwardstable';
import InwardRequestForm from '../Orders/Inwards/InwardRequestForm';
import InwardsTable from '../Orders/Inwards/InwardsTable';
import ReportsData from '../Charts/ReportsData';
import InwardAssignPickerForm from '../Orders/Inwards/InwardAssignPickerForm';
import OutwardAssignPickerForm from '../Orders/Outwards/OutwardAssignPickerForm';
import Pull from './Pull';
import CustomerRequest from './customerRequest';
import Shipper from './Shipper';
import ShippingPrep from './ShippingPrep';
import Shipping from './Shipping';
import Receiving from './Receiving';
import AssignTask from './AssignTask';
import Services from './Services';
import Returning from './returning';

function DashboardGridOrders() {
  const { dashboardStore } = useStore();

  const tableRenders = () => {
    switch (dashboardStore.dashboard.valueForL3Orders) {
      case 'Unvault':
      case 'VerifyOutward':
      case 'ApproveOutward':
      case 'Move':
      case 'Package':
        return (
          <Outwardstable name={dashboardStore.dashboard.valueForL3Orders} />
        );
      case 'AssignPickerOutward':
        return (
          <Grid stackable columns={2}>
            <Grid.Column>
              <Outwardstable name={dashboardStore.dashboard.valueForL3Orders} />
            </Grid.Column>
            <Grid.Column>
              <OutwardAssignPickerForm />
            </Grid.Column>
          </Grid>
        );
      case 'Billing':
        return (
          <Grid stackable columns={2}>
            <Grid.Column>
              <Outwardstable name={dashboardStore.dashboard.valueForL3Orders} />
            </Grid.Column>
            <Grid.Column>
              <DashboardBillingForm />
            </Grid.Column>
          </Grid>
        );
      // ----------------- Inward ----------------- //
      case 'Inward Request':
        if (dashboardStore.dashboard.L1CardValue === 'Orders') {
          return <InwardRequestForm />;
        } else {
          return <></>;
        }
      case 'Verify':
      case 'Approve':
      case 'Move To Vault':
        return (
          <InwardsTable name={dashboardStore.dashboard.valueForL3Orders} />
        );
      case 'Picker Assign':
        return (
          <Grid stackable columns={2}>
            <Grid.Column>
              <InwardsTable name={dashboardStore.dashboard.valueForL3Orders} />
            </Grid.Column>
            <Grid.Column>
              <InwardAssignPickerForm />
            </Grid.Column>
          </Grid>
        );
        case 'Customer Request':
          return(
            <CustomerRequest/>
          )
        case 'Shipper':
          return(
            <Shipper/>
          )
        case 'Pull':
          return(
           <Pull/>
          )
        case 'Shipping Prep':
          return(
            <ShippingPrep/>
          )
        case 'Shipping':
          return(
            <Shipping/>
          )
        case 'Receiving':
          return(
            <Receiving/>
          )
        case 'Customer Service Request':
          return(
            <CustomerRequest/>
          )
        case 'Assign Task to Personnal':
          return(
          <AssignTask/>
          )
        case 'Services':
          return(
          <Services/>
          )
        case 'Returning Services':
          return(
          <Returning/>
          )
      
      default:
        if (dashboardStore.dashboard.L1CardValue === 'Orders') {
          return (
            <Grid stackable>
              <Grid.Row>
                <ChartData />
              </Grid.Row>
              <Grid.Row>
                <ReportsData />
              </Grid.Row>
            </Grid>
          );
        } else return <></>;
    }
  };

  return <div>{tableRenders()}</div>;
}

export default observer(DashboardGridOrders);
